export default "__VITE_ASSET__ZJM2Rfox__"